angular.module('omfm').service('SaoClient', SaoClientService);

SaoClientService.$inject = ['$resource', 'ServerInterceptor'];

function SaoClientService($resource, ServerInterceptor) {
	return $resource('/sao', {"id": "@id"}, {
		'list':{
			'url':'/sao/client',
			'method': 'get',
			'interceptor': ServerInterceptor,
			'isArray': true
		},
		'generalTemplates': {
			'url':'/sao/general_templates',
			'method': 'get',
			'interceptor': ServerInterceptor
		},
		'saveGeneralTemplates': {
			'url':'/sao/general_templates',
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'listTemplates': {
			'url':'/sao/lists/:id/templates',
			'method': 'get',
			'interceptor': ServerInterceptor
		},
		'saveListTemplates': {
			'url':'/sao/lists/templates',
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'campaigns':{
			'url':'/sao/client/:id/campaigns',
			'method': 'get',
			'interceptor': ServerInterceptor,
			'isArray': true
		},
		'createList':{
			'url':'/sao/client/:id/list',
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'saveCampaign' :{
			'url':'/sao/client/list',
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'deleteList':{
			'url':'/sao/client/:id/list',
			'method': 'delete',
			'interceptor': ServerInterceptor
		},
		'get':{
			'url':'/sao/client/:id',
			'method': 'get',
			'interceptor': ServerInterceptor
		},
		'save':{
			'url':'/sao/client/:id',
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'importContact':{
			'url':'/sao/import_single_contact',
			'method': 'post',
			'interceptor': ServerInterceptor
		},

	})
}